import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import LayoutCourseProgressDemo from './CourseProgressDemo'
import CourseProgressElement from './CourseProgressElement'
import CourseProgressFormBrand from './CourseProgressFormBrand'
import { STYLE_FORM_SCHEMA } from './CourseProgressFormStyle'
import CourseProgressFormValue from './CourseProgressFormValue'
import icon from './assets/progress.svg'

export default genElementConfig(CONFIG_ELEMENTS.courseProgress, {
  icon,
  group: ElementGroup.cover,
  label: t('elements.courseProgress.label'),
  styleFields: STYLE_FORM_SCHEMA,
  Element: CourseProgressElement,
  Demo: [LayoutCourseProgressDemo],
  FormValue: CourseProgressFormValue,
  FormBrand: CourseProgressFormBrand,
  EditorActions: null,
})
